
import { Card, CardContent } from "@/components/ui/card";
import { Info, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface DemoBannerProps {
  className?: string;
}

const DemoBanner = ({ className }: DemoBannerProps) => {
  const navigate = useNavigate();

  return (
    <Card className={`border-blue-200 bg-blue-50 ${className}`}>
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          <Sparkles className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <h3 className="font-semibold text-blue-900 mb-1">Demo Store Data</h3>
            <p className="text-blue-800 text-sm mb-3">
              You're viewing sample data from a typical Etsy store with 7 orders and 4 products. 
              This gives you a preview of how your actual store data would look in our platform.
            </p>
            <Button 
              onClick={() => navigate('/signin')} 
              size="sm" 
              className="bg-blue-600 hover:bg-blue-700"
            >
              Sign In to Connect Your Store
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DemoBanner;
